export const getTitleOptionGroup = (isTitleVisible: boolean) => {
  return `${isTitleVisible ? 'Скрыть' : 'Показать'} заголовок группы`;
};
